// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_f921661d","img":"_bb50f0d","info":"_d2ccdbe0","category":"_905f7e9e","link":"_9bf100e"};